export const DOWNLOAD_TYPE_SINGLE = 'SINGLE';
export const DOWNLOAD_TYPE_MULTIPLE = 'MULTIPLE';
export const STATUS_DOWNLOAD_AVAILABLE = 'DOWNLOAD_AVAILABLE';
export const STATUS_DOWNLOADED = 'DOWNLOADED';


